import type { UUID } from "./uuid";

export const getMediaEngineDomain = (slackAppId: UUID): string => {
  if (
    import.meta.env.VITE_SERVICE_ENVIRONMENT === undefined ||
    import.meta.env.VITE_SERVICE_ENVIRONMENT === "local"
  ) {
    return "";
  }

  return `${slackAppId}-media${import.meta.env.VITE_SERVICE_ENVIRONMENT}.changeengine.com`;
};
